import videojs from 'video.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
const GLightbox = window.GLightbox;
const C7PDP = {
  init: function () {
    if (this.isProductPage()) {
      console.log('Initializing product page');

      // Special handling for tea towel product
      if (window.location.pathname.includes('/product/tea-towel---varietal')) {
        console.log('Tea towel product detected');
        // Add your special tea towel functionality here
        this.handleTeaTowelProduct();
      }

      this.waitForC7Content(() => {
        console.log('C7 content loaded');
        this.stickyPDP();
        this.removeGiftPrefix();
        this.extractVintage();

        // Add debug for price element before custom variants init
        const priceElementBefore = document.querySelector('.c7-product__add-to-cart__price');
        console.log('Price element before custom variants:', priceElementBefore);
        console.log('Price element display before:', priceElementBefore ? window.getComputedStyle(priceElementBefore).display : 'not found');

        this.initCustomVariants();

        // Debug price element after custom variants init
        const priceElementAfter = document.querySelector('.c7-product__add-to-cart__price');
        console.log('Price element after custom variants:', priceElementAfter);
        console.log('Price element display after:', priceElementAfter ? window.getComputedStyle(priceElementAfter).display : 'not found');

        // Ensure price is visible regardless of variants
        this.ensurePriceVisibility();

        this.setupProductImageShadow();
        console.log('Setting up product gallery');
        this.setupProductGallery();
        this.setupTastingNotes();
        this.setupPoints();
        this.setupLifestyleImages();
        this.removeEventPrefix();
        this.ensureTastingNotesDisplay();
      });
    }
  },

  isProductPage: function () {
    return window.location.pathname.includes('/product/');
  },

  handleTeaTowelProduct: function () {
    // Your special tea towel product page functionality goes here
    console.log('Handling tea towel specific functionality');

    // Example: Add a special class to the body
    document.body.classList.add('tea-towel-product');

    // Modify elements specific to this product
    const productContainer = document.querySelector('.product-details-cntr');
    if (productContainer) {
      productContainer.classList.add('tea-towel-layout');
    }
  },

  stickyPDPFlag: false,

  waitForC7Content: function (callback) {
    const observer = new MutationObserver((mutations, obs) => {
      const c7Content = document.getElementById('c7-content');
      if (c7Content && this.isC7ContentLoaded(c7Content)) {
        obs.disconnect();
        callback();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  },

  isC7ContentLoaded: function (c7Content) {
    return c7Content.children.length > 0 && c7Content.querySelector('.pdp-title') && c7Content.querySelector('.product-details-cntr');
  },

  // Add new function to ensure price visibility
  ensurePriceVisibility: function () {
    console.log('Running ensurePriceVisibility function');

    // We need to check for actual variants in the form, not just the empty container
    // There are two variant-radio-group elements - one outside the form (empty) and one inside
    const variantsInsideForm = document.querySelector('.c7-product__add-to-cart .variant-radio-group');
    const hasRealVariants = variantsInsideForm && variantsInsideForm.children.length > 0;

    console.log('Variants inside form:', !!variantsInsideForm);
    console.log('Has real variant children:', hasRealVariants);

    // Only proceed if there are no real variants
    if (hasRealVariants) {
      console.log('Real variants exist inside form, no need to inject price');
      return;
    }

    // Get the main product form's price element
    const priceElement = document.querySelector('.product-details-cntr .c7-product__add-to-cart__price');
    console.log('Main product price element:', priceElement);

    // Check if we already added a visible price
    const existingVisiblePrice = document.querySelector('.product-details-cntr .visible-price');
    if (existingVisiblePrice) {
      console.log('Visible price already exists, not adding another');
      return;
    }

    // Check for discounted pricing
    const hasDiscount = priceElement && priceElement.querySelector('.c7-price--discounted');
    console.log('Has discount pricing:', !!hasDiscount);

    if (hasDiscount) {
      // For discounted prices
      const originalPrice = priceElement.querySelector('.c7-price--original').textContent.trim();
      const discountedPrice = priceElement.querySelector('.c7-price--discounted').textContent.trim().replace('Now ', '');
      const formatText = priceElement.querySelector('.c7-product__variant__price__title')?.textContent || '';

      console.log('Original price:', originalPrice);
      console.log('Discounted price:', discountedPrice);

      // Create new price element with discount formatting
      const newPriceElement = document.createElement('div');
      newPriceElement.className = 'visible-price';
      newPriceElement.innerHTML = `<span class="original-price" style="text-decoration: line-through;">${originalPrice}</span> <span class="discounted-price">${discountedPrice}</span> (${formatText})`;

      // Find the main product form
      const form = document.querySelector('.product-details-cntr .c7-product__add-to-cart');

      if (form) {
        // Insert as first element in the main form
        form.insertBefore(newPriceElement, form.firstChild);
        console.log('Inserted discounted price element in main product form');
      }
    } else {
      // For regular, non-discounted prices
      const priceText = priceElement ? priceElement.textContent.match(/\$(\d+(?:\.\d{2})?)/) : null;
      const formatText = priceElement ? priceElement.querySelector('.c7-product__variant__price__title')?.textContent || '' : '';

      if (priceText) {
        // Create new price element
        const newPriceElement = document.createElement('div');
        newPriceElement.className = 'visible-price';
        newPriceElement.textContent = `${priceText[0]} (${formatText})`;

        // Find the main product form
        const form = document.querySelector('.product-details-cntr .c7-product__add-to-cart');

        if (form) {
          // Insert as first element in the main form
          form.insertBefore(newPriceElement, form.firstChild);
          console.log('Inserted regular price element in main product form');
        } else {
          console.log('Main product form not found for price insertion');
        }
      } else {
        console.log('Could not extract price text from main product area');
      }
    }
  },

  stickyPDP: function () {
    const pdpPinnedCTA = document.querySelector('.pdp-pinned-cart');
    if (!pdpPinnedCTA || this.stickyPDPFlag) return;
    this.stickyPDPFlag = true;

    gsap.set(pdpPinnedCTA, { y: '-100%' });

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: 'header.rmbr.header',
        start: 'bottom top',
        endTrigger: 'footer.rmbr.footer',
        end: 'bottom top',
        toggleActions: 'play reverse play reverse',
      },
    });

    tl.to(pdpPinnedCTA, { y: 0, duration: 0.25, ease: 'power1.out' });

    ScrollTrigger.refresh();
  },

  extractVintage: function () {
    const titleElement = document.querySelector('.pdp-title');
    const detailsContainer = document.querySelector('.product-details-cntr');

    if (titleElement && detailsContainer) {
      const titleText = titleElement.textContent.trim();

      const cleanedTitle = titleText.split('|').pop().trim();

      const match = cleanedTitle.match(/\b(\d{4})\b/);

      if (match) {
        const vintage = match[1];
        const restOfTitle = cleanedTitle.replace(vintage, '').trim();

        const vintageElement = document.createElement('p');
        vintageElement.className = 'vintage';
        vintageElement.textContent = vintage;

        titleElement.textContent = restOfTitle;

        detailsContainer.insertBefore(vintageElement, detailsContainer.firstChild);
      }
    }
  },
  initCustomVariants: function () {
    console.log('Starting initCustomVariants function');

    const customVariantsElement = document.querySelector('.metadata.custom-variants');
    if (!customVariantsElement) {
      console.log('Custom variants metadata element not found');

      // DEBUG: Check price element when no variants
      // const priceElement = document.querySelector('.c7-product__add-to-cart__price');
      // console.log('Price element when no variants found:', priceElement);
      // if (priceElement) {
      //   console.log('Current price display style:', window.getComputedStyle(priceElement).display);
      //   priceElement.style.display = 'block';
      //   console.log('Price style after setting display:', priceElement.style.display);
      //   console.log('Computed style after setting:', window.getComputedStyle(priceElement).display);
      // }

      document.querySelector('.product-details-cntr .format')?.remove();
      return;
    }

    let customVariants;
    try {
      const customVariantsContent = customVariantsElement.textContent.trim();
      customVariants = JSON.parse(customVariantsContent)['custom-variants'];
      console.log('Parsed custom variants:', customVariants);
    } catch (error) {
      console.error('Error parsing custom variants JSON:', error);
      return;
    }

    const formElement = document.querySelector('.product-details-cntr .c7-form');
    if (!formElement) {
      console.log('Form element not found');
      return;
    }

    // Get current product information
    const currentProductPriceElement = formElement.querySelector('.c7-product__add-to-cart__price');
    console.log('Current product price element:', currentProductPriceElement);

    const currentProductPrice = currentProductPriceElement ? currentProductPriceElement.textContent.match(/\$(\d+(?:\.\d{2})?)/)[1] : '';
    console.log('Current product price:', currentProductPrice);

    const currentProductSizeElement = currentProductPriceElement?.querySelector('.c7-product__variant__price__title');
    const currentProductSize = currentProductSizeElement ? currentProductSizeElement.textContent.trim() : '';
    console.log('Current product size:', currentProductSize);

    const currentProductUrl = window.location.pathname;

    // Create variant radio group
    const variantRadioGroup = document.createElement('div');
    variantRadioGroup.className = 'variant-radio-group';
    console.log('Created variant radio group element');

    // Combine current product with custom variants and sort by size
    const allVariants = [{ price: currentProductPrice, format: currentProductSize, url: currentProductUrl }, ...customVariants].sort((a, b) => {
      const sizeA = parseInt(a.format);
      const sizeB = parseInt(b.format);
      return sizeA - sizeB;
    });
    console.log('All variants after sorting:', allVariants);

    // Create radio buttons for all variants
    allVariants.forEach((variant, index) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'variant-radio-wrapper';

      const radioButton = document.createElement('input');
      radioButton.type = 'radio';
      radioButton.name = 'variant';
      radioButton.id = `variant-${index}`;
      radioButton.value = variant.url;
      radioButton.checked = variant.url === currentProductUrl;

      const label = document.createElement('label');
      label.htmlFor = `variant-${index}`;
      label.textContent = `$${parseFloat(variant.price).toFixed(2)} (${variant.format})`;

      wrapper.appendChild(radioButton);
      wrapper.appendChild(label);

      variantRadioGroup.appendChild(wrapper);
    });
    console.log('Created variant radio buttons, count:', variantRadioGroup.children.length);

    // Add event listener to the radio group
    variantRadioGroup.addEventListener('change', function (event) {
      if (event.target.type === 'radio') {
        const selectedUrl = event.target.value;
        if (selectedUrl && selectedUrl !== currentProductUrl) {
          window.location.href = selectedUrl;
        }
      }
    });

    // Insert the variant radio group as the first child of the form element
    formElement.insertBefore(variantRadioGroup, formElement.firstChild);
    console.log('Inserted variant radio group into the form');

    // Hide the original variant selector if it exists
    const originalVariantSelector = formElement.querySelector('.c7-product__variant-select');
    if (originalVariantSelector) {
      originalVariantSelector.style.display = 'none';
    }

    // Check if variants were created
    if (variantRadioGroup.children.length === 0) {
      console.log('No variant radio buttons were created, making price visible');
      if (currentProductPriceElement) {
        currentProductPriceElement.style.display = 'block';
        console.log('Set price element display to block');
      }
    }
  },

  createVariantButtons: function (variants) {
    const addToCartForm = document.querySelector('.product-details-cntr .c7-form.c7-product__add-to-cart');
    if (!addToCartForm) {
      console.log('Add to cart form not found');
      return;
    }

    const priceElement = addToCartForm.querySelector('.c7-product__add-to-cart__price');
    if (!priceElement) {
      console.log('Price element not found');
      return;
    }

    // Get the default selected variant information
    const defaultPriceText = priceElement.querySelector('span:not(.c7-sr-only)').textContent;
    const defaultPrice = parseFloat(defaultPriceText.replace('$', ''));
    const defaultFormat = priceElement.querySelector('.c7-product__variant__price__title').textContent;

    // Add the current page's variant if it's not already in the variants array
    const currentVariant = variants.find((v) => v.format === defaultFormat);
    if (!currentVariant) {
      variants.push({
        'variant-name': 'Current',
        price: defaultPrice,
        format: defaultFormat,
        url: window.location.pathname,
      });
    }

    // Sort variants from smallest to largest
    variants.sort((a, b) => this.compareFormats(a.format, b.format));

    // Create radio button group
    const variantGroup = document.createElement('div');
    variantGroup.className = 'variant-radio-group';

    variants.forEach((variant) => {
      const radioWrapper = document.createElement('div');
      radioWrapper.className = 'variant-radio-wrapper';

      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.id = `variant-${variant['variant-name']}`;
      radio.name = 'variant';
      radio.value = variant['variant-name'];
      radio.checked = variant.format === defaultFormat;

      const label = document.createElement('label');
      label.htmlFor = `variant-${variant['variant-name']}`;
      label.textContent = `$${variant.price.toFixed(2)} (${variant.format})`;

      radio.addEventListener('change', (event) => {
        const selectedVariant = variants.find((v) => v['variant-name'] === event.target.value);
        if (selectedVariant) {
          this.updateActiveVariant(selectedVariant, priceElement);
          if (selectedVariant.url !== window.location.pathname) {
            window.location.href = selectedVariant.url;
          }
        }
      });

      radioWrapper.appendChild(radio);
      radioWrapper.appendChild(label);
      variantGroup.appendChild(radioWrapper);
    });

    // Insert the variant group before the add to cart form
    addToCartForm.insertBefore(variantGroup, addToCartForm.firstChild);

    // Hide the original price element
    priceElement.style.display = 'none';
  },

  createVariantButton: function (variant, isActive) {
    const button = document.createElement('button');
    button.className = `custom-variant-button ${isActive ? 'active' : ''}`;
    button.textContent = variant.format;
    button.setAttribute('data-variant', JSON.stringify(variant));
    button.addEventListener('click', this.handleVariantClick.bind(this));
    return button;
  },

  createPriceElement: function (variant) {
    const priceElement = document.createElement('div');
    priceElement.className = 'c7-product__add-to-cart__price';
    priceElement.innerHTML = `
      <span class="c7-sr-only">Item Price</span>
      <span>$${variant.price.toFixed(2).replace('.', '<span>.')}</span></span>
      <span class="c7-product__add-to-cart__price__variant">
        <span class="c7-product__variant__price__title">${variant.format}</span>
      </span>
    `;
    return priceElement;
  },

  handleVariantClick: function (event) {
    const variantData = JSON.parse(event.target.getAttribute('data-variant'));
    this.updateActiveVariant(variantData);

    if (variantData.url !== window.location.pathname) {
      window.location.href = variantData.url;
    }
  },

  updateActiveVariant: function (variant, priceElement) {
    // Update the hidden price element
    priceElement.innerHTML = `
      <span class="c7-sr-only">Item Price</span>
      <span>$${variant.price.toFixed(2).replace('.', '<span>.')}</span></span>
      <span class="c7-product__add-to-cart__price__variant">
        <span class="c7-product__variant__price__title">${variant.format}</span>
      </span>
    `;

    // // Update the visible price
    // const visiblePrice = document.querySelector('.variant-radio-group + .visible-price');
    // if (visiblePrice) {
    //   visiblePrice.textContent = `$${variant.price.toFixed(2)}`;
    // } else {
    //   const newVisiblePrice = document.createElement('div');
    //   newVisiblePrice.className = 'visible-price';
    //   newVisiblePrice.textContent = `$${variant.price.toFixed(2)}`;
    //   priceElement.parentNode.insertBefore(newVisiblePrice, priceElement.nextSibling);
    // }
  },

  compareFormats: function (a, b) {
    const sizes = { 'ml': 1, 'L': 1000 };
    const [valueA, unitA] = a.match(/(\d+(?:\.\d+)?)(\w+)/).slice(1);
    const [valueB, unitB] = b.match(/(\d+(?:\.\d+)?)(\w+)/).slice(1);
    return parseFloat(valueA) * sizes[unitA] - parseFloat(valueB) * sizes[unitB];
  },

  setupProductImageShadow: function () {
    const figure = document.querySelector('.product-image-cntr figure');
    if (!figure) {
      console.log('Figure element not found');
      return;
    }

    const img = figure.querySelector('img');
    if (!img) {
      console.log('Image element not found within figure');
      return;
    }

    // Check if shadow image already exists
    if (figure.querySelector('.product-shadow-image')) {
      console.log('Shadow image already exists');
      return;
    }

    // Create shadow image
    const shadowImg = document.createElement('img');
    shadowImg.src = img.src;
    shadowImg.alt = '';
    shadowImg.classList.add('product-shadow-image');

    // Insert shadow image as the first child of the figure
    figure.insertBefore(shadowImg, figure.firstChild);

    // Adjust figure styles
    figure.style.position = 'relative';
  },

  setupProductGallery: function () {
    console.log('Setting up product gallery');
    const metadataElement = document.querySelector('.metadata.media-showcase');
    if (!metadataElement) {
      console.log('Media showcase metadata element not found');
      return;
    }

    let mediaShowcase;
    try {
      const metadataContent = metadataElement.textContent.trim();
      mediaShowcase = JSON.parse(metadataContent)['media-showcase'];
      console.log('Parsed media showcase:', mediaShowcase);
    } catch (error) {
      console.error('Error parsing metadata JSON:', error);
      return;
    }

    if (!mediaShowcase || !mediaShowcase['pdp-visual'] || !Array.isArray(mediaShowcase['pdp-visual'])) {
      console.log('No valid media showcase data found');
      return;
    }

    const galleryCtnr = document.querySelector('.product-image-cntr .gallery-ctnr');
    if (!galleryCtnr) {
      console.log('Gallery container not found');
      return;
    }

    console.log('Number of items in pdp-visual:', mediaShowcase['pdp-visual'].length);

    galleryCtnr.innerHTML = ''; // Clear existing content

    mediaShowcase['pdp-visual'].forEach((item, index) => {
      if (item.type === null || item.type === '') {
        return; // Skip this iteration
      }

      const thumbnailLink = document.createElement('a');
      thumbnailLink.href = item.src;
      thumbnailLink.className = 'gallery-thumbnail glightbox';
      thumbnailLink.setAttribute('data-gallery', 'product-gallery');

      const thumbnailImg = document.createElement('img');
      thumbnailImg.src = item.type === 'video' ? item.poster : item.src;
      thumbnailImg.alt = item.alt || `Product image ${index + 1}`;
      thumbnailLink.appendChild(thumbnailImg);

      if (item.type === 'video') {
        const playSvg = `
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" class="play-icon">
            <g filter="url(#filter0_b_8018_194)">
              <circle cx="16" cy="16" r="16" fill="white" fill-opacity="0.2"/>
              <circle cx="16" cy="16" r="15.5" stroke="white"/>
            </g>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.08 12.16L17.2947 13.9886L20.48 15.8466L17.2947 17.6752L14.08 19.5333V15.8466V12.16Z" fill="white"/>
            <defs>
              <filter id="filter0_b_8018_194" x="-10" y="-10" width="52" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="5"/>
                <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_8018_194"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_8018_194" result="shape"/>
              </filter>
            </defs>
          </svg>
        `;
        thumbnailLink.insertAdjacentHTML('beforeend', playSvg);
      }

      galleryCtnr.appendChild(thumbnailLink);
    });

    if (typeof GLightbox === 'function') {
      const lightbox = GLightbox({
        selector: '.glightbox',
        openEffect: 'zoom',
        closeEffect: 'fade',
        cssEfects: {
          fade: { in: 'fadeIn', out: 'fadeOut' },
          zoom: { in: 'zoomIn', out: 'zoomOut' },
        },
        touchNavigation: true,
        loop: true,
        autoplayVideos: false,
      });
    } else {
      console.error('GLightbox is not available');
    }
  },

  setupTastingNotes: function () {
    const MAX_RETRIES = 3;
    const RETRY_DELAY = 1000; // 1 second delay between retries

    const setupWithRetry = async (retryCount = 0) => {
      const tastingImagesContainer = document.querySelector('.tasting-notes-cntr .tasting-images');
      if (!tastingImagesContainer) {
        if (retryCount < MAX_RETRIES) {
          console.log(`Tasting container not found, retry ${retryCount + 1}/${MAX_RETRIES}`);
          setTimeout(() => setupWithRetry(retryCount + 1), RETRY_DELAY);
          return;
        }
        console.error('Tasting images container not found after all retries');
        return;
      }

      const dataDiv = tastingImagesContainer.querySelector('div');
      if (!dataDiv) {
        if (retryCount < MAX_RETRIES) {
          console.log(`Data div not found, retry ${retryCount + 1}/${MAX_RETRIES}`);
          setTimeout(() => setupWithRetry(retryCount + 1), RETRY_DELAY);
          return;
        }
        console.error('Data div not found after all retries');
        return;
      }

      const tastingData = dataDiv.textContent?.trim();
      if (!tastingData) {
        if (retryCount < MAX_RETRIES) {
          console.log(`No tasting data found, retry ${retryCount + 1}/${MAX_RETRIES}`);
          setTimeout(() => setupWithRetry(retryCount + 1), RETRY_DELAY);
          return;
        }
        console.error('No tasting data found after all retries');
        return;
      }

      try {
        // Parse and validate tasting items
        const tastingItems = tastingData
          .split('|')
          .map((item) => item.trim())
          .filter((item) => item.length > 0)
          .map((item) => {
            const [imageUrl, text] = item.split('---').map((part) => part.trim());
            if (!imageUrl || !text) {
              console.warn('Invalid tasting note format:', item);
              return null;
            }
            return { imageUrl, text };
          })
          .filter((item) => item !== null);

        if (tastingItems.length === 0) {
          if (retryCount < MAX_RETRIES) {
            console.log(`No valid tasting items found, retry ${retryCount + 1}/${MAX_RETRIES}`);
            setTimeout(() => setupWithRetry(retryCount + 1), RETRY_DELAY);
            return;
          }
          console.error('No valid tasting items found after all retries');
          return;
        }

        // Clear and setup container
        tastingImagesContainer.innerHTML = '';
        const textContainer = document.createElement('div');
        textContainer.className = 'tasting-text';
        tastingImagesContainer.appendChild(textContainer);

        // Function to load image with retry
        const loadImageWithRetry = (imageUrl, retryCount = 0) => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => {
              if (retryCount < MAX_RETRIES) {
                console.log(`Retrying image load: ${imageUrl}, attempt ${retryCount + 1}/${MAX_RETRIES}`);
                setTimeout(() => {
                  resolve(loadImageWithRetry(imageUrl, retryCount + 1));
                }, RETRY_DELAY);
              } else {
                console.error(`Failed to load image after ${MAX_RETRIES} retries:`, imageUrl);
                reject(new Error(`Failed to load image: ${imageUrl}`));
              }
            };
            img.src = imageUrl;
          });
        };

        // Create elements for valid items
        tastingItems.forEach(async (item, index) => {
          try {
            // Create and validate image
            const img = document.createElement('img');
            img.className = `tasting-icon tasting-icon-${index + 1}`;
            img.alt = item.text;

            try {
              await loadImageWithRetry(item.imageUrl);
              img.src = item.imageUrl;
            } catch (imageError) {
              img.style.display = 'none';
            }

            // Create text element
            const h3 = document.createElement('h3');
            h3.textContent = item.text;

            // Append elements
            textContainer.appendChild(img);
            textContainer.appendChild(h3);
          } catch (elementError) {
            console.error('Error creating tasting note element:', elementError);
          }
        });
      } catch (error) {
        if (retryCount < MAX_RETRIES) {
          console.log(`Error processing tasting notes, retry ${retryCount + 1}/${MAX_RETRIES}`);
          setTimeout(() => setupWithRetry(retryCount + 1), RETRY_DELAY);
          return;
        }
        console.error('Error setting up tasting notes after all retries:', error);
        tastingImagesContainer.innerHTML = `<div>${tastingData}</div>`;
      }
    };

    // Start the initial setup
    setupWithRetry();
  },

  setupPoints: function () {
    const pointsContainer = document.querySelector('.points-cntr');
    if (!pointsContainer) {
      console.log('Points container not found');
      return;
    }

    const pointsData = pointsContainer.textContent.trim();
    const pointsItems = pointsData.split('|').map((item) => item.trim());

    pointsContainer.innerHTML = ''; // Clear existing content

    // Add 'flat' class if there are not exactly 3 scores
    if (pointsItems.length !== 3) {
      pointsContainer.classList.add('flat');
    }

    pointsItems.forEach((item, index) => {
      const [imageUrl, points, source] = item.split('---');

      const columnDiv = document.createElement('div');
      columnDiv.className = 'points-column';

      // Create image
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = `Award ${index + 1}`;
      img.className = 'points-icon';
      columnDiv.appendChild(img);

      // Create points
      const pointsElement = document.createElement('p');
      pointsElement.className = 'points-value';
      // Add <br> tag after the asterisk
      pointsElement.innerHTML = points.replace('*', '<br>');
      columnDiv.appendChild(pointsElement);

      // Create source
      const sourceElement = document.createElement('p');
      sourceElement.className = 'points-source';
      sourceElement.innerHTML = source;
      columnDiv.appendChild(sourceElement);

      pointsContainer.appendChild(columnDiv);
    });
  },

  setupLifestyleImages: function () {
    const defaultImages = [
      'https://www.rombauer.com/wp-content/uploads/2021/08/Lifestyle-12_2126x1379_acf_cropped.jpg.webp',
      'https://www.rombauer.com/wp-content/uploads/2021/08/KM1_6401.jpg.webp',
      'https://www.rombauer.com/wp-content/uploads/2021/08/Rombauer-Client-Images-03-1_1600x1200_acf_cropped.jpg.webp',
    ];

    const container = document.querySelector('.rmbr.dynamic-lifestyle-cntr');
    if (!container) {
      console.error('Lifestyle images container not found');
      return;
    }

    const metadataElement = document.querySelector('.metadata.media-showcase');
    if (!metadataElement) {
      console.log('Media showcase metadata element not found');
      return;
    }

    let mediaShowcase;
    try {
      const metadataContent = metadataElement.textContent.trim();
      mediaShowcase = JSON.parse(metadataContent)['media-showcase'];
      console.log('Parsed media showcase:', mediaShowcase);
    } catch (error) {
      console.error('Error parsing metadata JSON:', error);
      return;
    }

    if (!mediaShowcase || !mediaShowcase['pdp-visual'] || !Array.isArray(mediaShowcase['pdp-visual'])) {
      console.log('No valid media showcase data found');
      return;
    }

    const showcaseImages = mediaShowcase['pdp-visual']
      .filter((item) => item.type === 'image')
      .map((item) => item.src)
      .filter((url) => url && url !== 'undefined' && url.trim() !== '');

    console.log('Showcase images found:', showcaseImages);

    const neededDefaultImages = Math.max(0, 3 - showcaseImages.length);

    const finalImages = [...showcaseImages, ...defaultImages.slice(0, neededDefaultImages)].slice(0, 3);

    console.log('Final images to be used:', finalImages);

    // Clear existing content and add new images
    container.innerHTML = '';
    finalImages.forEach((imageUrl, index) => {
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = `Lifestyle image ${index + 1}`;
      img.className = 'lifestyle-image';
      container.appendChild(img);
    });

    console.log('Final container HTML:', container.innerHTML);
  },

  removeGiftPrefix: function () {
    const titleElements = document.querySelectorAll('.pdp-title');

    titleElements.forEach((titleElement) => {
      if (titleElement && titleElement.textContent) {
        // Clean up the text: remove extra whitespace and newlines first
        let text = titleElement.textContent
          .replace(/[\n\r]+/g, '') // Remove newlines
          .replace(/\s+/g, ' ') // Replace multiple spaces with single space
          .trim(); // Remove leading/trailing whitespace

        // Remove "Gift:" prefix
        text = text.replace(/^Gift:\s*/i, '').trim();

        // Set the cleaned text
        titleElement.textContent = text;
      }
    });
  },

  removeEventPrefix: function () {
    const titleElements = document.querySelectorAll('.pdp-title');

    titleElements.forEach((titleElement) => {
      if (titleElement && titleElement.textContent) {
        let text = titleElement.textContent
          .replace(/[\n\r]+/g, '') // Remove newlines
          .replace(/\s+/g, ' ') // Replace multiple spaces with single space
          .trim(); // Remove leading/trailing whitespace

        // Log the cleaned text before prefix removal
        console.log('Cleaned text before prefix removal:', text);

        // Remove "Event:" prefix - modified to be more strict
        text = text.replace(/^[\s]*Event:[\s]*/i, '').trim();

        // Log the final text
        console.log('Final text:', text);

        // Set the cleaned text
        titleElement.textContent = text;
      }
    });
  },

  ensureTastingNotesDisplay: function () {
    // Wait for page to be fully loaded and give main function chance to work
    setTimeout(() => {
      const tastingContainer = document.querySelector('.tasting-notes-cntr .tasting-images');
      if (!tastingContainer) return;

      // Check if there's unparsed content
      const unparsedContent = tastingContainer.textContent || '';
      if (unparsedContent.includes('---') && unparsedContent.includes('|')) {
        console.log('Found unparsed tasting notes, attempting emergency cleanup');

        try {
          // Simple, bulletproof parsing
          const items = unparsedContent
            .split('|')
            .map((item) => {
              const parts = item.split('---');
              return {
                url: parts[0]?.trim(),
                text: parts[1]?.trim(),
              };
            })
            .filter((item) => item.url && item.text);

          if (items.length > 0) {
            // Clear container
            tastingContainer.innerHTML = '';

            // Create minimal structure
            const wrapper = document.createElement('div');
            wrapper.className = 'tasting-text';

            items.forEach((item, index) => {
              const img = document.createElement('img');
              img.src = item.url;
              img.alt = item.text;
              img.className = `tasting-icon tasting-icon-${index + 1}`;

              const text = document.createElement('h3');
              text.textContent = item.text;

              wrapper.appendChild(img);
              wrapper.appendChild(text);
            });

            tastingContainer.appendChild(wrapper);
            console.log('Emergency cleanup successful');
          }
        } catch (error) {
          console.error('Emergency cleanup failed:', error);
        }
      }
    }, 2000); // Wait 2 seconds after page load
  },
};

export default C7PDP;
